module.exports = __webpack_public_path__ + "img/person-dark-grey.dab91034.svg";